<template>
	<div>
		<TextTemp :data="terms" />
	</div>
</template>

<script>
	import TextTemp from './TextTemp'
	export default {
		name: 'Terms',
		components: {
			TextTemp,
		},
		data() {
			return {
				terms: {
					title: '服务条款',
					abstract: [
						'您正在使用MoPaaS平台（ 网址: https://www.mopaas.com )，在使用前请您仔细阅读如下服务协议。 所有使用MoPaaS的主体（包括但不限于个人、团队、公司等）（以下简称“用户”）针对MoPaaS的使用及相关服务订立的有效合约。MoPaaS用户使用MoPaaS即表示接受本协议的全部条款。本协议适用于任何MoPaaS服务，包括本协议期限内的用户使用的各项服务或软件的升级、调整及更新。'
					],
					item: [{
						title: '服务内容及使用须知',
						content: [
							'MoPaaS是一个向用户提供代码运行及管理的服务平台。MoPaaS提供云存储空间，用户可在此开发、上传、发布、运行代码。MoPaaS本身不直接上传、提供任何内容，对用户在平台上开发、上传、发布、运行的代码也不做任何修改或编辑。 用户理解，MoPaaS仅提供针对代码的存储及运行的空间平台，与开发、上传、发布、运行代码相关的所有成本，包括但不限于，用户为获得MoPaaS提供的MoPaaS中的收费部分（如有）（MoPaaS有权对该计费说明及优惠政策的内容进行随时调整，但MoPaaS会尽合理范围内的最大努力，将前述内容变化提前告知用户）而需支付的成本，均应由用户自行负担。 用户不得滥用MoPaaS。MoPaaS在此郑重提请您注意，任何用户在MoPaaS中开发、上传、发布、运行的代码，均由用户对其开发、上传、发布、运行的行为自行承担责任。 MoPaaS作为代码运行及管理的服务平台，无法控制MoPaaS中存储之内容，也无法对用户的行为进行全面控制，因此不能保证代码对应的前端应用的合法性、正确性、完整性、真实性或品质；网民使用前端应用时，可能接触到令人不快、不适当等内容，相关风险全部由用户自行承担，与MoPaaS无关。用户滥用MoPaaS的行为一经发现，MoPaaS有权立即终止向用户提供部分或全部MoPaaS服务。 若用户使用MoPaaS的行为不符合本协议，MoPaaS在经由通知、举报等途径发现时有权做出独立判断，且有权在无需事先通知用户情况下，立即终止向用户提供部分或全部MoPaaS服务。用户若散布、传播反动、色情或其他违反国家法律、法规的信息，该用户在MoPaaS中的所有数据（包含代码，数据，日志等）可能作为该用户违法的证据；因用户实施上述行为，导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户自行承担全部责任。 若MoPaaS经由通知、举报等途径，发现任何存在于用户在使用MoPaaS服务过程中相关产品中的违法、侵权信息和/或内容，无论其为用户自行或受托制作、开发、上传、发布，或为其它第三方，包括但不限于用户自行或受托制作、开发、上传、发布，MoPaaS均有权在第一时间将本条约定之违法、侵权信息和/或内容予以移除。'
						]
					},{
						title: '付费与退款 ',
						content: [
							'用户购买本服务时，须按照相关流程提交订单需求并确认订单信息，订单提交后，所提交的订单信息、公司信息、发票信息等任何信息将不可再进行任何修改，同时，用户应严格按照要求及时完成付款。',
							`用户可通过各种已有和未来新增的支付方式购买本服务，包括但不限于：网银支付、微信支付、支付宝支付或其他第三方支付等方式。`,
							`用户如需开具发票，可向客服人员提出开票申请，用户付款且到账后，可在1个月内提出开票申请，殷泊在自用户提出开票申请的7个工作日内开具发票并寄出。`,
							`本服务资费标准以MoPaaS网站上标注的详细资费标价为准，殷泊有权基于自身业务发展需要变更上述资费标准，但殷泊会根据实际运营情况对不同阶段已经激活且持续有效的用户给予续费、升级方面的不同资费优惠。`,
							`无退款声明：如用户已按MoPaaS网站指引完成对MoPaaS服务的购买行为，则用户已支付的款项，殷泊将不予退还。`,
							`体验金使用说明：新用户注册MoPaaS赠送的体验金有效期为7天，MoPaaS推出的充值满送活动，这类活动赠送金额有效期和充值金额一样。`
						]
					}, {
						title: '所有权',
						content: [
							'用户不得采取任何技术手段或具有破坏性的手段，侵害或意图侵害MoPaaS，对MoPaaS及其所有因素享有之所有权及知识产权。 提供、服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble），或以其他方式发现其原始编码，以及实施任何涉嫌侵害著作权的行为。'
						]
					}, {
						title: '承诺与保证',
						content: [
							`以任何方式干扰或企图干扰MoPaaS任何部分或功能的正常运行；`,
							`有任何病毒或破坏性数据、可能对MoPaaS产生不良影响；`,
							`避开、尝试避开或声称能够避开任何内容保护机制或者MoPaaS与环境度量工具；`,
							`导致应用使用者误认为其所使用的网站或应用是由MoPaaS提供；`,
							`使用任何标志，包括但不限于以对此类标志的所有者的权利的玷污、削弱和损害的方式使用MoPaaS标志，或者以违背本协议的方式为自行或向其他任何人设定或声明设定任何义务或授予任何权利或权限；`,
							`用户违反上述任何一款保证，MoPaaS均有权就其情节，对其做出处罚；如因用户违反上述保证而给MoPaaS、或其他用户以及MoPaaS任何合作伙伴造成损失，用户自行负责承担一切法律责任并赔偿损失。`
						]
					}, {
						title: '不得含有任何违反国家法律法规政策的信息',
						content: ['(1)反对宪法所确定的基本原则的；', '(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；', '(3)损害国家荣誉和利益的；', '(4)煽动民族仇恨、民族歧视，破坏民族团结的；',
							'(5)破坏国家宗教政策，宣扬邪教和封建迷信的；', '(6)散布谣言，扰乱社会秩序，破坏社会稳定的；', '(7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
							'(8)侮辱或者诽谤他人，侵害他人合法权益的；', '(9)含有盗版音频、视频、图片、图书和/或其它任何侵犯第三方任何合法权益作品的。', '(10)含有法律、行政法规禁止的其他内容的。'
						]
					}, {
						title: '知识产权及隐私声明',
						content: [
							'MoPaaS充分尊重用户知识产权，未经用户允许，MoPaaS不会以任何形式查看、修改、使用、发行用户代码。',
							'MoPaaS自行设置、实施技术措施，对用户存储于MoPaaS中的代码予以保护，防止用户代码被查看、修改或泄露。'
						]
					}, {
						title: '免责行为',
						content: [
							'用户理解，MoPaaS需对其MoPaaS定期或不定期进行升级、维护，如因此类情况造成用户享有服务受到影响，MoPaaS无需为此承担任何责任，但MoPaaS应尽可能事先通知用户。',
							'若发生用户违背本协议约定或违反法律、法规规定之情形，由用户自行承担一切法律、经济后果，MoPaaS不承担任何责任。'
						]
					}, {
						title: '不可抗力',
						content: [
							'“不可抗力”系指在本协议期限内发生的不可预见（或虽可预见，但其发生或后果不可控制、避免），非任何一方所能控制且使任何一方无法完全履行本协议的诸事件。鉴于互联网之特殊性质，不可抗力亦包括下列影响互联网正常运行之情形：黑客攻击；电信部门技术调整导致之重大影响；因政府管制而造成之暂时关闭；病毒侵袭；网络故障、带宽、域名解析故障或其他网络设备或技术提供商的服务延迟、服务障碍或任何其他类似事件。 声称遭受不可抗力的一方，应立即用可能最快捷的方式通知另一方该事件的性质、发生日期、预计持续时间等有关的细节，以及该事件阻碍通知方履行其于本协议项下义务的程度，并随附经有关部门确认的不可抗力书面证明，且应尽可能减少不可抗力所产生的影响。'
						]
					}, {
						title: '其他',
						content: [
							'本协议最终解释权归MoPaaS所有。', 
							`本协议项下MoPaaS对用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。`,
							`本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向MoPaaS所在地的人民法院提起诉讼。`,
							`本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。`,
							`如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。`
							
						]
					}]
				}
			}
		}
	}
</script>

<style>
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Terms.vue